import { ChangeDetectionStrategy, Component } from '@angular/core'

@Component({
  selector: 'privacy',
  imports: [],
  templateUrl: './privacy.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class Privacy {}
